import React from 'react';
import InputField from 'components/Global/InputField';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import { ReactComponent as BlueMappinIcon } from '../../../../../icons/mappin-icon-blue.svg';
import BlueMappin from 'icons/mappin-icon-blue.svg';
import YellowMappin from 'icons/mappin-icon-yellow.svg';
import L from 'leaflet';
import { ReactComponent as Calendar } from 'icons/calendar-icon.svg';
import { ReactComponent as Clock } from 'icons/clock-icon.svg';
import { ReactComponent as CharterSgIcon } from 'icons/charter-sg-dark-blue-icon.svg';
import { FeatureFlag } from 'utils/feature-flag';
import { format } from 'date-fns';
import { checkEmptyObject, getDurationExtend } from 'utils/functionality';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderDisbursementById } from 'features/orders/actions';

const ImmutableFormComponent = ({ areaCharterData, imagePreviewHandler }) => {
  const dispatch = useDispatch();

  const { selectedDisbursement } = useSelector((state) => state.detailOrder);
  const { data: paymentData } = useSelector((state) => state.payment);

  const customIconBlue = L.icon({
    iconUrl: BlueMappin,
    iconSize: [20, 20],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
  });

  const customIconYellow = L.icon({
    iconUrl: YellowMappin,
    iconSize: [20, 20],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
  });

  useEffect(() => {
    if (!areaCharterData?.extension || areaCharterData?.extension?.length === 0) return;

    const fetchDisbursementExtendCharter = async () => {
      try {
        await dispatch(getOrderDisbursementById(areaCharterData.extension[0]?.order_transaction_key)).unwrap();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    };

    fetchDisbursementExtendCharter();
  }, [areaCharterData]);

  return (
    <div className="immutable-form">
      <InputField
        label="Pick Up"
        disable
        readOnly
        value={areaCharterData?.pickup_location_name || '-'}
        icon={<BlueMappinIcon />}
        iconPosition={'start'}
      />

      <InputField
        label="Drop Off"
        disable
        readOnly
        value={areaCharterData?.dropoff_location_name || '-'}
        icon={<BlueMappinIcon />}
        iconPosition={'start'}
      />

      {areaCharterData?.pickup_zone_lat && areaCharterData?.pickup_zone_long && (
        <MapContainer
          center={[areaCharterData?.pickup_zone_lat, areaCharterData?.pickup_zone_long]}
          zoom={13}
          style={{ height: '203px', width: '100%' }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker
            position={[areaCharterData?.pickup_zone_lat, areaCharterData?.pickup_zone_long]}
            icon={customIconBlue}
          >
            <Popup>{areaCharterData?.detail_pickup_location}</Popup>
          </Marker>
        </MapContainer>
      )}

      {areaCharterData?.drop_off_zone_lat && areaCharterData?.drop_off_zone_long && (
        <MapContainer
          center={[areaCharterData?.drop_off_zone_lat, areaCharterData?.drop_off_zone_long]}
          zoom={13}
          style={{ height: '203px', width: '100%' }}
        >
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker
            position={[areaCharterData?.drop_off_zone_lat, areaCharterData?.drop_off_zone_long]}
            icon={customIconYellow}
          >
            <Popup>{areaCharterData?.order?.detail_drop_off_location}</Popup>
          </Marker>
        </MapContainer>
      )}

      <InputField label="Detail Lokasi" disable readOnly value={areaCharterData?.detail_pickup_location || '-'} />

      <InputField label="Detail Lokasi" disable readOnly value={areaCharterData?.detail_drop_off_location || '-'} />

      <InputField
        label="Rental Area"
        disable
        readOnly
        value={areaCharterData?.detail_driving_location || '-'}
        className="rental-area"
      />

      <FeatureFlag flagKey={'FLAG_EXTEND_CHARTER'} entityId={'anonymus'}>
        {Object.prototype.hasOwnProperty.call(areaCharterData, 'extension') &&
          areaCharterData?.extension?.length !== 0 && (
            <div className="extend-order">
              <h2>Extend Order</h2>
              <div className="data-form">
                <InputField
                  label="Tanggal"
                  icon={<Calendar />}
                  iconPosition={'start'}
                  disable
                  readOnly
                  value={
                    areaCharterData?.extension[0]?.booking_start_date
                      ? format(new Date(areaCharterData?.extension[0]?.booking_start_date), 'dd MMMM yyyy')
                      : '-'
                  }
                />
                <div className="payment-method">
                  <InputField
                    label="Metode Pembayaran"
                    disable
                    readOnly
                    value={
                      paymentData && !checkEmptyObject(selectedDisbursement)
                        ? paymentData.find((pay) => pay.id === selectedDisbursement?.payment_method_id)?.method
                        : '-'
                    }
                  />
                  {selectedDisbursement?.disbursement_confirmation_image && (
                    <div className="payment-method__image-payment">
                      <InputField
                        label="Bukti Pembayaran"
                        disable
                        readOnly
                        value={
                          selectedDisbursement?.disbursement_confirmation_image
                            ? selectedDisbursement?.disbursement_confirmation_image?.split('/')[
                                selectedDisbursement?.disbursement_confirmation_image?.split('/')?.length - 1
                              ]
                            : '-'
                        }
                      />
                      <button
                        type="button"
                        className="btn-preview"
                        onClick={() => imagePreviewHandler(selectedDisbursement.disbursement_confirmation_image)}
                      >
                        Lihat
                      </button>
                    </div>
                  )}
                </div>
                <InputField
                  label="Tambahan Durasi"
                  icon={<CharterSgIcon />}
                  iconPosition={'start'}
                  disable
                  readOnly
                  value={
                    areaCharterData?.charter_duration_label
                      ? `${areaCharterData?.charter_duration_label} (${areaCharterData?.extension[0]?.charter_duration} Jam)`
                      : '-'
                  }
                />
                <InputField
                  label="Jam Tersedia"
                  icon={<Clock />}
                  iconPosition={'start'}
                  disable
                  readOnly
                  value={
                    areaCharterData?.extension[0]?.booking_start_time && areaCharterData?.extension[0]?.booking_end_time
                      ? `${getDurationExtend(
                          areaCharterData?.extension[0]?.booking_start_time,
                          areaCharterData?.extension[0]?.charter_duration,
                          areaCharterData?.extension[0]?.booking_end_time,
                        )} Jam`
                      : '-'
                  }
                />
              </div>
            </div>
          )}
      </FeatureFlag>
    </div>
  );
};

export default ImmutableFormComponent;
